import React, {useState} from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';

import { 
	AUTH_PREFIX_PATH, 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY 
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	
	const { token } = useSelector(state => state.auth)
	const location = useLocation()
	const [defLocation,setDefLocation] = useState("/public/home");
	//console.log({token})
	//TODO => cek dulu disini untuk liat apakah usernya masih boleh login apa tidak, jiga tidak maka diredirect ke halaman login atau public home



	if (!token) {
		//return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
		return <Navigate to={defLocation} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute